<div class="led" data-testid="ledger">
    <div class="led-scroll">
        <table class="led-table" data-testid="ledger-table">
            <thead>
                <tr class="led-head">
                    <th class="led-head__cell" data-testid="ledger-column" scope="col">
                        {{ 'abcp_ledger_col_date' | i18next }}
                    </th>
                    <th class="led-head__cell led-head__cell--text" data-testid="ledger-column" scope="col">
                        {{ 'abcp_ledger_col_text' | i18next }}
                    </th>
                    <th class="led-head__cell" data-testid="ledger-column" scope="col">
                        {{ 'abcp_ledger_col_account' | i18next }}
                    </th>
                    <th class="led-head__cell" data-testid="ledger-column" scope="col">
                        {{ 'abcp_ledger_col_account_label' | i18next }}
                    </th>
                    <th class="led-head__cell" data-testid="ledger-column" scope="col">
                        {{ 'abcp_ledger_col_vat' | i18next }}
                    </th>
                    <th class="led-head__cell led-head__cell--value" data-testid="ledger-column" scope="col">
                        {{ 'abcp_ledger_col_debit' | i18next }}
                    </th>
                    <th class="led-head__cell led-head__cell--value" data-testid="ledger-column" scope="col">
                        {{ 'abcp_ledger_col_credit' | i18next }}
                    </th>
                    <th class="led-head__cell led-head__cell--value" data-testid="ledger-column" scope="col">
                        {{ 'abcp_ledger_col_balance' | i18next }}
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr *ngIf="showSkeleton">
                    <td class="led-state" [attr.colspan]="columnCount">
                        <div class="led-loading" data-testid="ledger-loading">
                            <div class="led-skeleton" *ngFor="let skeleton of skeletonRows" aria-hidden="true"></div>
                        </div>
                    </td>
                </tr>

                <tr *ngIf="!loading && error">
                    <td class="led-state" [attr.colspan]="columnCount">
                        <div class="led-error" data-testid="ledger-error">{{ 'abcp_ledger_error' | i18next }}</div>
                    </td>
                </tr>

                <tr *ngIf="!loading && !error && isEmpty">
                    <td class="led-state" [attr.colspan]="columnCount">
                        <div class="led-empty" data-testid="ledger-empty">{{ 'abcp_ledger_empty' | i18next }}</div>
                    </td>
                </tr>

                <ng-container *ngIf="!error && !isEmpty">
                    <ng-container *ngFor="let row of rows; trackBy: trackByRowId">
                        <tr
                            class="led-row led-row--booking"
                            data-testid="ledger-row"
                            data-kind="booking"
                            *ngIf="row.kind === 'booking'"
                            [class.has-foreign]="hasForeignLine(row)"
                            [class.is-comment]="row.hasComment"
                            [class.is-selected]="isSelected(row)"
                            [class.is-pending]="row.id === pendingRowId"
                            [attr.data-pending]="row.id === pendingRowId ? 'true' : null"
                            [attr.data-row-id]="row.id"
                            [attr.data-comment]="row.hasComment ? 'true' : null"
                            [attr.aria-current]="isSelected(row) ? 'true' : null"
                            role="button"
                            tabindex="0"
                            (click)="onRowClick(row)"
                            (keydown.enter)="onRowClick(row)"
                            (keydown.space)="onRowClick(row); $event.preventDefault()"
                        >
                            <td class="led-cell led-cell--date" data-testid="ledger-cell">{{ row.date }}</td>
                            <td class="led-cell led-cell--text" data-testid="ledger-cell">
                                <div class="led-text-cell">
                                    <span
                                        class="ham-icon led-comment"
                                        data-testid="ledger-comment-icon"
                                        *ngIf="row.hasComment"
                                        aria-hidden="true"
                                    >
                                        <i class="message-caption-icon"></i>
                                    </span>
                                    <span class="led-text">{{ row.text }}</span>
                                    <!-- The line's own click and keys would toggle the selection off again. -->
                                    <ham-button
                                        *ngIf="isSelected(row)"
                                        class="led-mark"
                                        data-testid="ledger-mark-action"
                                        variant="gray"
                                        size="toolbar"
                                        (click)="$event.stopPropagation()"
                                        (keydown)="$event.stopPropagation()"
                                        (buttonClick)="onMarkClick(row)"
                                    >
                                        {{ 'abcp_ledger_mark_comment' | i18next }}
                                    </ham-button>
                                    <!-- The same line as the start of a Pendenz. -->
                                    <ham-button
                                        *ngIf="isSelected(row)"
                                        class="led-mark led-mark--next"
                                        data-testid="ledger-mark-todo"
                                        variant="gray"
                                        size="toolbar"
                                        (click)="$event.stopPropagation()"
                                        (keydown)="$event.stopPropagation()"
                                        (buttonClick)="onMarkTodoClick(row)"
                                    >
                                        {{ 'abcp_ledger_mark_todo' | i18next }}
                                    </ham-button>
                                </div>
                            </td>
                            <td class="led-cell led-cell--account" data-testid="ledger-cell">
                                <span class="led-account">{{ row.accountNumber }}</span>
                            </td>
                            <td class="led-cell led-cell--account-label" data-testid="ledger-cell">
                                {{ row.accountLabel }}
                            </td>
                            <td class="led-cell led-cell--vat" data-testid="ledger-cell">{{ row.vatCode }}</td>

                            <ng-container
                                *ngTemplateOutlet="amountCell; context: { $implicit: row.debit }"
                            ></ng-container>
                            <ng-container
                                *ngTemplateOutlet="amountCell; context: { $implicit: row.credit }"
                            ></ng-container>
                            <ng-container
                                *ngTemplateOutlet="amountCell; context: { $implicit: row.balance }"
                            ></ng-container>
                        </tr>

                        <!-- The booking in another currency: its amount in the debit or credit column, the
                             rate in the text column, and on a foreign-currency account the balance in it. -->
                        <tr
                            class="led-row led-row--foreign"
                            data-testid="ledger-foreign-row"
                            *ngIf="row.kind === 'booking' && row.foreign"
                        >
                            <td class="led-cell led-cell--date"></td>
                            <td class="led-cell led-cell--text" colspan="4" data-testid="ledger-foreign-rate">
                                {{ 'abcp_ledger_foreign_rate' | i18next }} {{ row.foreign.rate | finNumber: '1.4-4' }}
                            </td>
                            <ng-container
                                *ngTemplateOutlet="
                                    amountCell;
                                    context: { $implicit: row.foreign.side === 'debit' ? row.foreign.amount : null }
                                "
                            ></ng-container>
                            <ng-container
                                *ngTemplateOutlet="
                                    amountCell;
                                    context: { $implicit: row.foreign.side === 'credit' ? row.foreign.amount : null }
                                "
                            ></ng-container>
                            <ng-container
                                *ngTemplateOutlet="amountCell; context: { $implicit: row.foreignBalance }"
                            ></ng-container>
                        </tr>

                        <tr
                            class="led-row led-row--title"
                            data-testid="ledger-row"
                            data-kind="title"
                            *ngIf="row.kind === 'title'"
                            [class.has-foreign]="hasForeignLine(row)"
                            [class.is-comment]="row.hasComment"
                            [class.is-selected]="isSelected(row)"
                            [attr.data-comment]="row.hasComment ? 'true' : null"
                            [attr.aria-current]="isSelected(row) ? 'true' : null"
                            [attr.role]="row.hasComment ? 'button' : null"
                            [attr.tabindex]="row.hasComment ? 0 : null"
                            (click)="onRowClick(row)"
                            (keydown.enter)="onRowClick(row)"
                            (keydown.space)="onRowClick(row); $event.preventDefault()"
                        >
                            <td class="led-cell led-cell--date" data-testid="ledger-cell">{{ row.date }}</td>
                            <td class="led-cell led-cell--text" data-testid="ledger-cell" colspan="6">
                                <span
                                    class="ham-icon led-comment"
                                    data-testid="ledger-comment-icon"
                                    *ngIf="row.hasComment"
                                    aria-hidden="true"
                                >
                                    <i class="message-caption-icon"></i>
                                </span>
                                <span class="led-text">{{ titleLabelKey(row.variant) | i18next }}</span>
                            </td>

                            <ng-container
                                *ngTemplateOutlet="amountCell; context: { $implicit: row.balance }"
                            ></ng-container>
                        </tr>

                        <tr
                            class="led-row led-row--foreign led-row--foreign-title"
                            data-testid="ledger-foreign-row"
                            *ngIf="row.kind === 'title' && hasForeignLine(row)"
                        >
                            <td class="led-cell led-cell--date"></td>
                            <td class="led-cell led-cell--text" colspan="6"></td>
                            <ng-container *ngIf="row.foreignBalance; else foreignUnavailable">
                                <ng-container
                                    *ngTemplateOutlet="amountCell; context: { $implicit: row.foreignBalance }"
                                ></ng-container>
                            </ng-container>
                            <ng-template #foreignUnavailable>
                                <td class="led-cell led-cell--value" data-testid="ledger-foreign-unavailable">
                                    {{ row.foreignUnavailable }} {{ 'abcp_ledger_foreign_unavailable' | i18next }}
                                </td>
                            </ng-template>
                        </tr>
                    </ng-container>
                </ng-container>
            </tbody>
        </table>
    </div>

    <div class="led-more" *ngIf="canLoadMore && !error && !isEmpty">
        <ham-button
            data-testid="ledger-load-more"
            variant="white"
            outline
            size="sm"
            icon="/assets/hamIcons/rotate-90-outline.svg"
            [disabled]="loadingMore"
            (buttonClick)="onLoadMoreClick()"
        >
            {{ 'abcp_ledger_load_more' | i18next }}
        </ham-button>
    </div>
</div>

<ng-template #amountCell let-amount>
    <td class="led-cell led-cell--value" data-testid="ledger-cell">
        <span class="led-value" *ngIf="amount"
            ><span class="led-currency" *ngIf="amount.currency">{{ amount.currency }}&nbsp;</span
            >{{ amount.value | finNumber: '1.2-2' }}</span
        >
    </td>
</ng-template>
